import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { schema, schemaDefaultValue } from "./schema";
import { useCallback, useContext, useEffect, useState } from "react";
import LibMask from "../../../../util/mask";
import Notification, { handleMessageError, handleMessageWarning } from "../../../toast";
import { ContextGlobal } from "../../../../context";
import { searchCep } from "../../../../util/libSearchCep";
import LibBoolean from "../../../../util/libBool";
import { ContextRegisterSupplier } from "../context";
import reqFornecedor from "../../../../services/reqMultiTenant/reqFornecedor";
import { useAddress } from "../../../../hook/useAddress";

export const IndexHooks = () => {
	const { brazilStates, fetchCitiesByUf, loadingCities, listPermissionsData } = useContext(ContextGlobal);

	const { closeModalRegisterSupplier, isOpenModalRegisterSupplier, id_fornecedor, setSupplierData, supplierData } =
		useContext(ContextRegisterSupplier);

	const [loading, setLoading] = useState(false);
	const [citiesData, setCitiesData] = useState([]);

	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		getValues,
		// trigger,
		setError,
		reset,
		watch,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "all",
		reValidateMode: "onChange",
		resolver: zodResolver(schema),
		defaultValues: schemaDefaultValue,
	});

	//#region Carregar dados do funcionario selecionado
	const fetchSupplier = async () => {
		try {
			setLoading(true);

			try {
				if (id_fornecedor > 0) {
					const response = await reqFornecedor.listID(id_fornecedor);

					if (typeof response.data === "object" && response.data !== null) {
						const supplierData = response.data;

						const ativoValue = supplierData.ativo === "SIM"; // Converte "SIM" para true, "NAO" para false
						const pessoafisica = supplierData.pessoa_fisica === "SIM"; // Converte "SIM" para true, "NAO" para false

						supplierData.ativo = ativoValue;
						supplierData.pessoafisica = pessoafisica;

						if (supplierData.cep === null) supplierData.cep = "";

						Object.keys(supplierData).forEach((field) => {
							setValue(field, supplierData[field]);
						});

						await handleFetchCitiesByUf(supplierData.uf);
					}
				} else {
					const lUF = listPermissionsData?.uf || "SP";
					const lId_Cidade = listPermissionsData?.id_cidade;

					setValue("uf", lUF);
					setValue("id_cidade", lId_Cidade);

					await handleFetchCitiesByUf(lUF);
				}
			} catch (error) {
				handleMessageError(error.message);
				closeModalRegisterSupplier();
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (isOpenModalRegisterSupplier === true) {
			fetchSupplier();
		}
	}, [isOpenModalRegisterSupplier]);
	//#endregion

	//#region Buscar Cidades pelo estado
	const handleFetchCitiesByUf = async (uf) => {
		try {
			const responseCities = await fetchCitiesByUf(uf); // Aqui vai a função para buscar as cidades

			setCitiesData(responseCities);
		} catch (error) {
			handleMessageWarning(error.message);
		}
	};
	//#endregion

	//#region Selecionar estado e buscar as cidades
	const handleSelectedState = async (selectedOption) => {
		// quando selecionar o estado no input chama essa função
		await handleFetchCitiesByUf(selectedOption.value);

		setValue("id_cidade", "");
	};
	//#endregion

	//#region Pesquisar e preenche o endereço pelo cep
	const { handleFetchAddressByCep, cepIsSubmitting } = useAddress(setValue, setFocus, getValues);

	const handleFetchAddress = async () => {
		try {
			const uf = await handleFetchAddressByCep();
			handleFetchCitiesByUf(uf);
		} catch (error) {
			handleMessageWarning(error.message);
		}
	};
	//#endregion

	//#region mascaras

	const telefone_1 = watch("telefone_1");
	useEffect(() => {
		setValue("telefone_1", LibMask.phone(telefone_1));
		if (telefone_1?.length !== 14) return;
	}, [telefone_1, setValue]);

	const telefone_2 = watch("telefone_2");
	useEffect(() => {
		setValue("telefone_2", LibMask.phone(telefone_2));
		if (telefone_2?.length !== 14) return;
	}, [telefone_2, setValue]);

	//#endregion

	//#region
	const handleOnSubmit = async (data) => {
		try {
			const newAtivo = LibBoolean.booleanToStr(data.ativo);
			const newPessoaFisica = LibBoolean.booleanToStr(data.pessoafisica);

			const nomeFinal = (!data.nome || data.nome.trim() === "") ? data.fantasia : data.nome;

			const newDataSupplier = {
				...data,
				nome: nomeFinal,
				// fantasia: data.fantasia.toUpperCase(),
				// rua: data.rua ? data.rua.toUpperCase() : null,
				// bairro: data.bairro ? data.bairro.toUpperCase() : null,
				ativo: newAtivo,
				pessoafisica: newPessoaFisica,
			};

			const responseSupplier = await reqFornecedor.insert(newDataSupplier);

			const currentIdSupplier = responseSupplier.data[0].id_fornecedor;

			await reloadSupplierData(currentIdSupplier);

			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});
		} catch (error) {
			if (error.field) errosAfterPost(error.field, error.message);

			Notification.showToast({ message: error.message, type: "error" });
		}
	};

	const reloadSupplierData = async (currentId) => {
		try {
			try {
				//lista o cliente no qual foi feita a inserção ou alteração
				const response = await reqFornecedor.listID(currentId);
				//pego somente o primeiro pq neste caso mando sempre 1 resgistro por vez
				const responseData = response.data;
				//se é inserção ou alteração. Inserção só adiciona mais um registro no array
				if (id_fornecedor === 0) {
					setSupplierData((prevState) => [...prevState, responseData]);
				} else {
					//se for update ele procura na lista aonde ta o cliente que foi selecionado e altera somente ele
					const newSupplierData = supplierData.map((item) => {
						if (item.id_fornecedor === responseData.id_fornecedor) {
							return responseData;
						}
						return item;
					});
					setSupplierData(newSupplierData);
				}
			} catch (error) {
				console.log(error.message);
			}
		} finally {
			reset();
			closeModalRegisterSupplier();
		}
	};

	const errosAfterPost = (field, message) => {
		setError(field?.toLowerCase(), { type: "manual", message: message });
	};
	//#endregion
	const handleCloseModal = () => {
		reset();
		closeModalRegisterSupplier();
	};

	return {
		//hook form
		errors,
		isSubmitting,
		register,
		Controller,
		control,
		handleSubmit,
		handleOnSubmit,

		citiesData,

		//variaveis de estado
		loading,
		loadingCities,
		cepIsSubmitting,

		//context
		isOpenModalRegisterSupplier,
		brazilStates,

		//funções
		handleSelectedState,
		handleFetchAddress,
		handleCloseModal,
	};
};
